import { render, staticRenderFns } from "./SignatureDocIcon.vue?vue&type=template&id=0dc7fc5c&"
import script from "./SignatureDocIcon.vue?vue&type=script&lang=js&"
export * from "./SignatureDocIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports